import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
    return (
        <div>
            <header className="header-area header-one header--sticky">
                <div className="header-container-one">
                    <div className="header-wrapper">
                        <a href="index.html" className="logo">
                            <img src="assets/images/main-logo.png" alt="logo" />
                        </a>
                        <div className="header-right">

                            <nav className="nav-area drop-down-rts">
                                <ul className="navbar-nav-1">
                                    <li className="menu-item">
                                        <a className="menu-link" href="/"><span className="rolling-text">Home</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/about"><span className="rolling-text">About Us</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/services"><span className="rolling-text">Services</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/portfolio"><span
                                            className="rolling-text">Portfolio</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/blogs"><span className="rolling-text">Blogs</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/contact"><span className="rolling-text">Contact</span></a>
                                    </li>
                                    <li className="menu-item">
                                        <a className="menu-link" href="/getaqute"><span className="rolling-text">Get a
                                            Quote</span></a>
                                    </li>
                                </ul>
                            </nav>

                            <div className="action-area">

                                <div className="menu-btn">

                                    <div className="rts-offcanvas-wrapper">
                                        <div className="container-menu">
                                            <div className="action-menu">
                                                <div className="close-event"></div>
                                                <div className="open-event">

                                                    <div className="burger">
                                                        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                                                            className="icon-close" data-v-649bbaab="">
                                                            <line x1="13.788" y1="1.28816" x2="1.06011" y2="14.0161"
                                                                stroke="currentColor" stroke-width="1.2"></line>
                                                            <line x1="1.06049" y1="1.43963" x2="13.7884" y2="14.1675"
                                                                stroke="currentColor" stroke-width="1.2"></line>
                                                        </svg>
                                                        <svg viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                                                            className="icon-burger" data-v-649bbaab="">
                                                            <line x1="18" y1="0.6" y2="0.6" stroke="currentColor"
                                                                stroke-width="1.2" data-v-649bbaab=""></line>
                                                            <line x1="18" y1="5.7167" y2="5.7167" stroke="currentColor"
                                                                stroke-width="1.2" data-v-649bbaab=""></line>
                                                            <line x1="18" y1="10.8334" y2="10.8334" stroke="currentColor"
                                                                stroke-width="1.2" data-v-649bbaab=""></line>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="rts-fs-menu">
                                            <div className="rts-fs-container row">

                                                <div className="rts-fs--nav col-12 col-md-6">
                                                    <ul id="primary-menu" className="navbar-nav-button">
                                                        <li className="menu-item"><a href="/">Home</a></li>
                                                        <li className="menu-item"><a href="/about">About Us</a></li>
                                                        <li className="menu-item"><a href="/services">Services</a></li>
                                                        <li className="menu-item"><a href="/portfolio">Portfolio</a></li>
                                                        <li className="menu-item"><a href="/blogs">Blogs</a></li>
                                                        <li className="menu-item"><a href="/contact">Contact</a></li>
                                                        <li className="menu-item"><a href="/getaqute">Get a Quote</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="rts-fs--contacts col-12 col-md-6">
                                                    <div className="contact-inner">
                                                        <div className="contact-information">
                                                            <h2 className="heading-title">Our Office</h2>
                                                            <div className="address">
                                                                <ul>
                                                                    <li>
                                                                        <p>3rd Floor, SSS Plaza, Mahatma Nagar,
                                                                            Kizhakkumpattukara,<br /> Thrissur, Kerala 680005</p>
                                                                    </li>

                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="contact-information">
                                                            <h2 className="heading-title">Get In Touch</h2>
                                                            <div className="contact">
                                                                <ul>
                                                                    <li><a href="mailto:support@warmonks.com"
                                                                        className="mail">support@warmonks.com</a></li>
                                                                    <li><a href="tel:+91 9778544561" className="number">+91
                                                                        9778544561</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="rts-social-area-one">
                                                                <ul>
                                                                    <li><a href="https://www.facebook.com/profile.php?id=100075545787839" target='_blank'><i class="fa-brands fa-facebook-f"></i></a></li>
                                                                    <li><a href="https://www.instagram.com/team_warmonks/" target='_blank'><i class="fa-brands fa-instagram"></i></a></li>
                                                                    <li><a href="https://api.whatsapp.com/send?phone=919778544561&text=We%20welcome%20you%20to%20join%20us....%E2%98%BA%EF%B8%8F" target='_blank'><i class="fa-brands fa-whatsapp"></i></a></li>
                                                                    <li><a href="https://www.linkedin.com/company/warmonks/posts/?feedView=all" target='_blank'><i class="fa-brands fa-linkedin"></i></a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Header
